import React, { useMemo, useState } from 'react';
import { LockIcon } from 'lucide-react';
import { AdminEmptyState, AdminMetricCard, AdminPageTitle, AdminSearch, AuditEntry, DateRange, FilterBar, FilterSelect, Panel } from '../../components/admin/AdminPrimitives';
import { auditLog, roleLabels, team } from '../../data/admin';
import { useLocale } from '../../contexts/LocaleContext';
export function AdminAudit() {
  const {
    tl
  } = useLocale();
  const [query, setQuery] = useState('');
  const [admin, setAdmin] = useState('all');
  const [entity, setEntity] = useState('all');
  const [range, setRange] = useState('30d');
  const entries = useMemo(() => {
    const term = query.trim().toLowerCase();
    return auditLog.filter(entry => {
      if (admin !== 'all' && entry.admin !== admin) return false;
      if (entity !== 'all') {
        const isUser = entry.entity.startsWith('u');
        const isContent = entry.entity.startsWith('post') || entry.entity.startsWith('ct');
        if (entity === 'user' && !isUser) return false;
        if (entity === 'content' && !isContent) return false;
        if (entity === 'platform' && entry.entity !== 'platform') return false;
      }
      if (!term) return true;
      return tl(entry.action).toLowerCase().includes(term) || entry.entity.toLowerCase().includes(term) || tl(entry.context).toLowerCase().includes(term);
    });
  }, [query, admin, entity, tl]);
  return <div className="space-y-4" data-id="element-1526" data-mp="2h61fybkauqul">
      <AdminPageTitle title="Auditoria" subtitle="Registro imutável das ações administrativas relevantes, com autor, entidade e estado anterior." action={<DateRange value={range} onChange={setRange} data-id="element-1528" data-mp="27f6isc5im6ud" />} data-id="element-1527" data-mp="2m4co8huy4tap" />

      <section className="grid grid-cols-2 gap-3 lg:grid-cols-4" data-id="element-1529" data-mp="2cdhpwf4fe38w">
        <AdminMetricCard label="Eventos (30d)" value="1.284" delta={2.4} data-id="element-1530" data-mp="3043w00uvddg9" />
        <AdminMetricCard label="Ações sensíveis" value="212" delta={-1.8} accent data-id="element-1531" data-mp="30210j1ay6s45" />
        <AdminMetricCard label="Administradores ativos" value="6" data-id="element-1532" data-mp="34wf0zi4gvpfo" />
        <AdminMetricCard label="Exportações auditadas" value="34" delta={4.1} data-id="element-1533" data-mp="3er2kpo2cdtra" />
      </section>

      <FilterBar data-id="element-1534" data-mp="39rhpnoqam5ju">
        <AdminSearch value={query} onChange={setQuery} placeholder="Buscar ação, entidade ou contexto" data-id="element-1535" data-mp="39t13l8oh84ig" />
        <FilterSelect label="Administrador" value={admin} onChange={setAdmin} options={[{
        id: 'all',
        label: 'Todos'
      }, ...team.map(member => ({
        id: member.name,
        label: member.name
      }))]} data-id="element-1536" data-mp="35ol01e2c596e" />
        <FilterSelect label="Entidade" value={entity} onChange={setEntity} options={[{
        id: 'all',
        label: 'Todas'
      }, {
        id: 'user',
        label: 'Usuário'
      }, {
        id: 'content',
        label: 'Conteúdo'
      }, {
        id: 'platform',
        label: 'Plataforma'
      }]} data-id="element-1537" data-mp="2r0zvrgtq53ww" />
      </FilterBar>

      <Panel title="Eventos" hint="Somente leitura. Entradas de auditoria não podem ser editadas nem removidas." action={<span className="flex items-center gap-1 text-[11px] font-medium text-muted" data-id="element-1539" data-mp="nja6bctej5b9">
            <LockIcon size={13} aria-hidden="true" data-id="element-1540" data-mp="sin1ckuffiox" />
            Imutável
          </span>} data-id="element-1538" data-mp="2d3bcuej7w6uh">
        {entries.length === 0 ? <AdminEmptyState title="Nenhum evento encontrado" body="Ajuste o administrador, a entidade ou o período." data-id="element-1541" data-mp="xgeshcn8z0s2" /> : <ul data-id="element-1542" data-mp="4uwr8hw9sn3d">
            {entries.map(entry => <AuditEntry key={entry.id} admin={entry.admin} role={tl(roleLabels[entry.role])} action={tl(entry.action)} entity={entry.entity} timestamp={entry.timestamp} context={tl(entry.context)} before={entry.before} after={entry.after} sensitive={entry.severity === 'sensitive'} data-id="element-1543" data-mp="9sybh65fmsgf" />)}
          </ul>}
      </Panel>
    </div>;
}